import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetListEvents = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_EVENT
            });
            if (data.status === 'success') {
                const events = [...getState().adminMobile.events.data];
                events.push(data.data);
                dispatch(Action.SetGetListEventsAction({
                    data: events.flat(1),
                    countPage: data.countPage
                }));
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetListEvents as SetGetListEvents
}